import type { LiveProvider } from "@refinedev/core";

type PollingSubscription = { timer: number };

export const liveProvider: LiveProvider = {
  subscribe: ({ channel, callback }) => {
    const timer = window.setInterval(() => {
      callback({ channel, type: "updated", payload: {}, date: new Date() });
    }, 5_000);
    return { timer } satisfies PollingSubscription;
  },
  unsubscribe: (subscription) => {
    window.clearInterval((subscription as PollingSubscription).timer);
  },
};
